import { gql } from '@apollo/client'

const deleteVenueDevice = gql(`
  mutation deleteVenueDevice ( $deviceId: String!, $project: String!, $email: String ) {
    deleteVenueDevice (deviceId: $deviceId, project : $project, email: $email) {
      success
      error {
        message
        code
      }
      }
  }`)

export default deleteVenueDevice
